import { render, staticRenderFns } from "./original.vue?vue&type=template&id=23eca286&scoped=true"
import script from "./original.vue?vue&type=script&lang=js"
export * from "./original.vue?vue&type=script&lang=js"
import style0 from "./original.vue?vue&type=style&index=0&id=23eca286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eca286",
  null
  
)

export default component.exports